export default {
    props: ['filterTypes', 'view', 'heading', 'dataKey'],

    data() {
        return {
            checkedTypes: [],
        };
    },

    watch: {
        checkedTypes: function (checked) { // eslint-disable-line object-shorthand, func-names
            // Gather data
            const data = {
                key: this.dataKey,
                values: checked,
            };

            // Emit to parent
            this.$emit('update-product-types', data);
        },
    },

    template: `
        <transition name="fade">
            <div v-if="this.filterTypes && this.view">
                <h5 class="h6 search-filter__grid-heading">{{ heading }}</h5>
                <div class="layout">
                    <div class="search-filter__input-group" v-for="type in filterTypes">
                        <input class="search-filter__input" :name="type.slug" type="checkbox" :id="type.slug" :value="type.id" v-model="checkedTypes">
                        <label :for="type.slug" class="search-filter__label">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon search-filter__checkbox-checked"
                        >
                        <g fill="none" fill-rule="evenodd"><path stroke="#EF6E0B" stroke-width="2" d="M1 1h18v18H1z"/>
                        <rect fill="#EF6E0B" x="5" y="5" width="10" height="10" rx="5"/>
                        </g>
                        </svg>

                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                                class="icon search-filter__checkbox-unchecked"
                            >
                                <path d="M1 1h18v18H1z" stroke="#EF6E0B" stroke-width="2" fill="none" fill-rule="evenodd"/>
                            </svg>
                            <span>{{ type.title }}</span>
                        </label>
                    </div>
                </div>
            </div>
        </transition>
    `,
};
